/* TODO: t() */
import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Modal } from '../../uiold';

import { useSimpleViewDispatch, useSimpleViewState } from './Context';
import DateSelector from './DateSelector';
import ModalVendorList from './ModalVendorList';
import PlacementControl from './PlacementControl';

type Props = {
  placeVendorToAllDates: () => void;
  placeVendorToEmptyDates: () => void;
  stallName: string;
};

function SimpleViewPlacementModal({
  placeVendorToAllDates,
  placeVendorToEmptyDates,
  stallName,
}: Props) {
  let dispatch = useSimpleViewDispatch();
  let {
    activeIndex,
    activeVendor,
    isPlacingToSpecificDates,
  } = useSimpleViewState();
  let showDateSelection =
    activeIndex != null && activeVendor && isPlacingToSpecificDates;

  return (
    <Modal
      isVisible
      style={[styles.root, isPlacingToSpecificDates && styles.expandedModal]}
      onClose={() => dispatch({ type: 'DISMISS_MODAL' })}
    >
      <Modal.Header title={stallName} />
      <Modal.Body>
        <View style={styles.modalContent}>
          <View style={styles.vendorSelection}>
            <View style={{ flex: 1 }}>
              <ModalVendorList width={modalInnerWidth} height={374} />
            </View>
            <PlacementControl
              placeVendorToAllDates={placeVendorToAllDates}
              placeVendorToEmptyDates={placeVendorToEmptyDates}
            />
          </View>
          {showDateSelection && (
            <>
              <View style={{ width: 24 }} />
              <DateSelector />
            </>
          )}
        </View>
      </Modal.Body>
    </Modal>
  );
}

let modalWidth = 380;
let modalHorizontalPadding = 24;
let modalInnerWidth = modalWidth - 2 * modalHorizontalPadding;

let styles = StyleSheet.create({
  root: {
    width: 'auto',
    maxWidth: modalWidth,
    transitionProperty: 'max-width',
    transitionDuration: '0.2s',
    transitionTimingFunction: 'ease-out',
  },
  expandedModal: {
    maxWidth: 900,
  },
  modalContent: {
    height: 500,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  vendorSelection: {
    maxWidth: modalInnerWidth,
  },
});

export default SimpleViewPlacementModal;
